import React, { createContext, useContext, useReducer, PropsWithChildren } from 'react';
import { HomeReducer, initialState, HomeState, HomeAction } from './home-reducer';

const HomeStateContext = createContext<HomeState | undefined>(undefined);
const HomeDispatchContext = createContext<React.Dispatch<HomeAction> | undefined>(undefined);

export const HomeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(HomeReducer, initialState);

  return (
    <HomeStateContext.Provider value={state}>
      <HomeDispatchContext.Provider value={dispatch}>
        {children}
      </HomeDispatchContext.Provider>
    </HomeStateContext.Provider>
  );
};

export const useHomeState = (): HomeState => {
  const context = useContext(HomeStateContext);
  if (context === undefined) {
    throw new Error('useHomeState must be used within a HomeProvider');
  }
  return context;
};

export const useHomeDispatch = (): React.Dispatch<HomeAction> => {
  const context = useContext(HomeDispatchContext);
  if (context === undefined) {
    throw new Error('useHomeDispatch must be used within a HomeProvider');
  }
  return context;
};
